import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/auth",
    children: [
      {
        name: "auth-login",
        path: "login",
        component: () => import("../presentation/pages/Login.vue"),
        meta: {
          layout: "blank",
          public: true,
        },
      },
      {
        name: "auth-forgot-password",
        path: "forgot-password",
        component: () => import("../presentation/pages/ForgotPassword.vue"),
        meta: {
          layout: "blank",
          public: true,
        },
      },
      {
        name: "auth-reset-password",
        path: "reset-password/:token",
        component: () => import("../presentation/pages/ResetPassword.vue"),
        meta: {
          layout: "blank",
          public: true,
        },
      },
      {
        name: "auth-verify-otp",
        path: "verify-otp",
        component: () => import("../presentation/pages/VerifyOtp.vue"),
        meta: {
          layout: "blank",
          public: true,
        },
      },
      {
        name: "auth-access-denied",
        path: "access-denied",
        component: () => import("../presentation/pages/AccessDenied.vue"),
        meta: {
          layout: "blank",
          public: true,
        },
      },
    ],
  },
];
